import {
  SCHEDULE_SESSION_LIST,
  SELECTED_SCHEDULE_SESSION_ID,
  ALL_SCHEDULE_SESSION_IDS,
  LIVE_QA_LIST,
  UNPUBLISHED_LIVE_QA_LIST,
  SELECT_PUBLISHED_TYPE,
  LIVE_QA_REPLIES,
  BROADCAST_QA,
  ALL_PUBLISHED_SESSIONWISE_LIVE_QA_LIST,
  LIVE_QA_EXPORT_MODAL,
  SCHEDULE_SESSION_RATING,
  ALL_SCHEDULE_SESSION_RATING,
  SCHEDULE_SESSION_CHECKOUT_FORM,
} from "LiveQAAction";

export function scheduleSessions(state = {}, action) {
  switch (action.type) {
    case SCHEDULE_SESSION_LIST:
      return action.payload;
    default:
      return state;
  }
}
export function selectedSession(state = {}, action) {
  switch (action.type) {
    case SELECTED_SCHEDULE_SESSION_ID:
      return action.payload;
    default:
      return state;
  }
}
export function allSessionId(state = {}, action) {
  switch (action.type) {
    case ALL_SCHEDULE_SESSION_IDS:
      return action.payload;
    default:
      return state;
  }
}
export function livePublishedQAList(state = {}, action) {
  switch (action.type) {
    case LIVE_QA_LIST:
      return action.payload;
    default:
      return state;
  }
}
export function liveUnpublishedQAList(state = {}, action) {
  switch (action.type) {
    case UNPUBLISHED_LIVE_QA_LIST:
      return action.payload;
    default:
      return state;
  }
}
export function selectPublishedType(state = {}, action) {
  switch (action.type) {
    case SELECT_PUBLISHED_TYPE:
      return action.payload;
    default:
      return state;
  }
}
export function liveQAReplies(state = {}, action) {
  switch (action.type) {
    case LIVE_QA_REPLIES:
      return action.payload;
    default:
      return state;
  }
}
export function broadcastLiveQA(state = {}, action) {
  switch (action.type) {
    case BROADCAST_QA:
      return action.payload;
    default:
      return state;
  }
}
export function allPublishesSessionwiseLiveQA(state = {}, action) {
  switch (action.type) {
    case ALL_PUBLISHED_SESSIONWISE_LIVE_QA_LIST:
      return action.payload;
    default:
      return state;
  }
}

export var ShowLiveQAExportModal = (
  state = { show: false, key: "" },
  action
) => {
  if (action.type === LIVE_QA_EXPORT_MODAL) {
    return action.payload;
  }
  return state;
};

export function singleSessionRatings(state = {}, action) {
  switch (action.type) {
    case SCHEDULE_SESSION_RATING:
      return action.payload;
    default:
      return state;
  }
}

export function allSessionRatings(state = {}, action) {
  switch (action.type) {
    case ALL_SCHEDULE_SESSION_RATING:
      return action.payload;
    default:
      return state;
  }
}

export function singleSessionCheckouForm(state = {}, action) {
  switch (action.type) {
    case SCHEDULE_SESSION_CHECKOUT_FORM:
      return action.payload;
    default:
      return state;
  }
}
